/**
 * Background: there was an issue where scripts that handled state were not being shared across chunks,
 * which resulted in multiple instances of the same script being loaded. This resulted on odd runtime behavior.
 * This was fixed by configuring webpack to use a single runtime chunk,
 * but using globalThis is an additional safeguard to ensure that the state is shared across all chunks.
 */
/**
 * Helper to ensure a global state is initialized and accessible across all chunks.
 * @param key - The key to use for the global state
 * @param defaultValue - The default value to return if the key is not found
 * @returns The value of the global state, or the default value if the key is not found
 */
export function ensureGlobalState(key, defaultValue) {
    const symbol = Symbol.for(key);
    return globalThis[symbol] ?? (globalThis[symbol] = defaultValue);
}
export function logInstanceId(key) {
    console.debug(`${key} loading with instance id: ` + Math.random().toString(36).substring(2, 15));
}
